import { Reducer } from 'redux';
import { LOCALSTORAGE_TOKEN_FIELD } from '../../../types/app.index';
import {
  AuthenticationActionTypes,
  AuthenticationState,
  LOGIN_FAILED,
  LOGIN_SUCCESSFUL,
  LOGOUT_SUCCESSFUL,
  STORE_ACTIVE_SUPPLIER,
  STORE_NEW_TOKEN,
  STORE_USER_CHANGES,
  TOKEN_INVALID
} from '../types/authentication.types';

const initialState: AuthenticationState = {
  token: null,
  user: null,
  loginFailed: false,
  suppliers: [],
  activeSupplier: null
};

export const authenticationReducer: Reducer<AuthenticationState> = (
  state: AuthenticationState = initialState, action
) => {
  switch ((action as AuthenticationActionTypes).type) {
    case LOGIN_SUCCESSFUL:
      return {
        token: action.payload.token,
        user: action.payload.user,
        loginFailed: false,
        suppliers: action.payload.suppliers,
        activeSupplier: action.payload.activeSupplier
      };
    case LOGIN_FAILED:
      return {
        ...state,
        loginFailed: true
      };
    case LOGOUT_SUCCESSFUL:
      return {
        token: null,
        user: null,
        loginFailed: false,
        suppliers: null,
        activeSupplier: null
      };
    case TOKEN_INVALID:
      return {
        ...state,
        token: null
      };
    case STORE_ACTIVE_SUPPLIER:
      return {
        ...state,
        activeSupplier: action.payload.activeSupplier
      };
    case STORE_NEW_TOKEN:
      localStorage.setItem(LOCALSTORAGE_TOKEN_FIELD, action.payload.token);
      return {
        ...state,
        token: action.payload.token
      };
    case STORE_USER_CHANGES:
      return {
        ...state,
        user: action.payload.user
      };
    default:
      return state;
  }
};
